import React from "react";

import { useSelector } from "react-redux";

import {
  DeploymentPermission,
  SaleyardPermission,
} from "constants/permissions";
import { MissingFieldsIndicatorTypes } from "constants/saleLots";

import {
  getIsCurrentSaleClearingSale,
  selectIsUnderValidationThersholdBySaleLotId,
  selectNASFieldWarningsBySaleLotId,
} from "selectors";

import {
  useHasDentitionPermission,
  useHasSaleyardOrDeploymentPermission,
  useGetMissingFieldWarnings,
} from "hooks";
import { NASMissingFieldsIndicatorProps } from "./types";
import {
  MissingFieldsIndicatorBase,
  defaultNutrienWarnings,
} from "./MissingFieldsIndicator";

export const checkUnderThreshold = (validations, modelIds) =>
  modelIds.some(modelId => {
    const validationToCheck = validations[modelId] || {};
    return (
      validationToCheck.missingDentition || validationToCheck.missingWeightRange
    );
  });

export function NASMissingFieldsIndicator(
  props: NASMissingFieldsIndicatorProps,
): React.JSX.Element {
  const { keyValue, onlyAdvancedFields = false } = props;

  const hasDentitionPermission = useHasDentitionPermission();

  const hasWeightRangePermission = useHasSaleyardOrDeploymentPermission(
    DeploymentPermission.featureWeightRange,
    SaleyardPermission.featureWeightRange,
  );

  const isClearingSale = useSelector(getIsCurrentSaleClearingSale);

  const hasMissingNasFieldsSaleLotIdLookup = useSelector(
    selectNASFieldWarningsBySaleLotId,
  );

  let keyValues = keyValue;
  if (!Array.isArray(keyValues)) {
    keyValues = [keyValues];
  }

  const warnings = useGetMissingFieldWarnings({
    modelIds: keyValues,
    lookup: hasMissingNasFieldsSaleLotIdLookup,
    defaultWarnings: defaultNutrienWarnings,
  });

  const validations = useSelector(selectIsUnderValidationThersholdBySaleLotId);
  const underThreshold = checkUnderThreshold(validations, keyValues);

  if (
    !hasWeightRangePermission ||
    !hasDentitionPermission ||
    onlyAdvancedFields ||
    isClearingSale
  ) {
    return null;
  }

  return (
    <MissingFieldsIndicatorBase
      label={MissingFieldsIndicatorTypes.NAS}
      warnings={warnings}
      areFieldsUnderWarningThreshold={underThreshold}
    />
  );
}
